import React from 'react';
import './index.scss';

import {
  BUTTON_NO_PREV,
  BUTTON_CONF,
  BUTTON_DEFAULT,
  BUTTON_BACKLP,
  BUTTON_NONE,
  BUTTON_LINK_ONLY,
  BUTTON_NEXT_PREV,
  BUTTON_BEFORE_CONF,
} from 'utils/constant';
import NextButton from 'components/atoms/Button/NextButton';
import PrevButton from 'components/atoms/Button/PrevButton';
import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';

const empty = () => {};

const PcButtonArea = ({
  onClickMainButton = {},
  nextUrl,
  prevUrl,
  valid,
  buttonType,
}) => {

  const prevClick = onClickMainButton.prev ? (e) => onClickMainButton.prev(e) : empty;
  const nextClick = onClickMainButton.next ? (e) => onClickMainButton.next(e) : empty;
  
  // 次へのみのボタン
  const NoPrevButton = () => (
    <>
      <div className="button-area">
        <div className="nextOnly">
          <NextButton label='下記に同意して確認画面へ' onClick={nextClick} link={nextUrl} valid={valid} />
        </div>
      </div>
      <div className="privacy-pollicy">
        <a href="/sol/cont/sitepolicy/" target="_blank">利用規約</a>
        ・
        <a href="/sol/cont/privacy/" target="_blank">プライバシーポリシー</a>
        ・
        <a href="/sol/cont/personal_information/" target="_blank">個人関連情報の取り扱い</a>
        {' '}
        にご同意いただいたうえで送信してください。
      </div>
    </>
  );

  // 標準のボタン
  const DefaultButton = () => (
    <>
      <div className="button-area">
        <div className="prev">
          <PrevButton label='入力内容を修正する' link={prevUrl} onClick={prevClick} />
        </div>
        <div className="next">
          <NextButton label='この内容で依頼する' link={nextUrl} onClick={nextClick} valid={valid} />
        </div>
      </div>
    </>
  );
  // 中間画面用のボタン
  const NextPrevButton = () => (
    <>
      <div className="button-area">
        <div className="prev">
          <PrevButton label='戻る' link={prevUrl} onClick={prevClick} />
        </div>
        <div className="next">
          <NextButton label='次へ' link={nextUrl} onClick={nextClick} valid={valid} />
        </div>
      </div>
    </>
  );
  // 確認画面のボタン
  const ConfButton = () => (
    <>
      <div className="button-area">
        <div className="prev">
          <PrevButton label='戻る' link={prevUrl} onClick={prevClick} />
        </div>
        <div className="next">
          <NextButton label='この内容で依頼する' link={nextUrl} onClick={nextClick} valid={valid} />
        </div>
      </div>
    </>
  );
  // 確認画面前のボタン
  const BeforeConfButton = () => (
    <>
      <div className="button-area">
        <div className="prev">
          <PrevButton label='戻る' link={prevUrl} onClick={prevClick} /> 
        </div>
        <div className="next">
          <NextButton label='下記に同意して確認画面へ' link={nextUrl} onClick={nextClick} valid={valid} />
        </div>
      </div>
      <div className="privacy-pollicy">
        <a href="/sol/cont/sitepolicy/" target="_blank">利用規約</a>
        ・
        <a href="/sol/cont/privacy/" target="_blank">プライバシーポリシー</a>
        ・
        <a href="/sol/cont/personal_information/" target="_blank">個人関連情報の取り扱い</a>
        {' '}
        にご同意いただいたうえで送信してください。
      </div>
    </>
  );
  // LPに戻るボタン
  const BackLpButton = () => (
    <>
      <div className="button-area">
        <div className="backLp">
          <PrevButton label='戻る' link={nextUrl} onClick={nextClick} />
        </div>
      </div>
    </>
  );

  // 同意URLのみ
  const LinkOnly = () => (
    <>
      <div className="privacy-pollicy">
        <a href="/sol/cont/sitepolicy/" target="_blank">利用規約</a>
        ・
        <a href="/sol/cont/privacy/" target="_blank">プライバシーポリシー</a>
        ・
        <a href="/sol/cont/personal_information/" target="_blank">個人関連情報の取り扱い</a>
        {' '}
        にご同意いただいたうえで送信してください。
      </div>
    </>
  );

  const FooterButtons = {
    [BUTTON_DEFAULT]: (
      <>
        <div className="border" />
        <DefaultButton />
      </>
    ),
    [BUTTON_CONF]: (
      <>
        <div className="border" />
        <ConfButton />
      </>
    ),
    [BUTTON_BEFORE_CONF]: (
      <>
        <div className="border" />
        <BeforeConfButton />
      </>
    ),
    [BUTTON_NO_PREV]: (
      <>
        <div className="border" />
        <NoPrevButton />
      </>
    ),
    [BUTTON_NEXT_PREV]: (
      <>
        <div className="border" />
        <NextPrevButton />
      </>
    ),
    [BUTTON_BACKLP]: (
      <>
        <div className="border" />
        <BackLpButton />
      </>
    ),
    [BUTTON_NONE]: '',
    [BUTTON_LINK_ONLY]: (
      <>
        <LinkOnly />
      </>
    )
  };
  return (
    <div className="PcButtonArea" id="FooterButtons">
      <div className="wrapper">
        {FooterButtons[buttonType]}
      </div>
    </div>
  );
};

export default PcButtonArea;